import * as React from "react";
import { Storage } from '../storage'

/**
 * @param WrappedComponent
 * @param  {[type]} nextState [description]
 * @param  {[type]} replace   [description]
 * @return {[type]}           [description]
 */
export default function withSession(WrappedComponent: any) {
  return class extends React.Component {
    /**
     * Render the main content
     * @returns {null}
     */
    render() {
      return <WrappedComponent {...this.props} session={Storage.get('meCurrent')} />
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/withSession/index.tsx